/**
 * A1 -- an authority boundary, said in words.
 *
 * `ApiError.message` is `API ${status}: ${detail}`, so a refused
 * signature reached the CRO as "API 403: realm role business_owner
 * required" -- a status code and a schema name, for a person being
 * told the record is not hers.
 *
 * Deliberately narrow. Only 401 and 403 are translated: those are
 * ALWAYS an authority answer, and the server's own words add nothing a
 * reader can act on. Every other failure keeps its detail, because
 * that detail is usually the diagnosis -- a connector's own error text
 * is what tells an operator which credential is wrong, and burying it
 * behind a friendly sentence was a defect in its own right.
 *
 * Returns null when the error is not a refusal, so a caller can fall
 * through to whatever it showed before.
 */
import { ApiError } from "shared/api/client";

export function refusalKey(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null;
  if (error.status === 403) return "errors.refused.forbidden";
  if (error.status === 401) return "errors.refused.signedOut";
  return null;
}
